import { RegionId, TenantRegion, UserId } from "@sp-crm/core";
import { makeInitialAdvancedSearchRequest } from "components/reports/show/custom-reports/custom-reports-helpers";
import {
    AdvancedSearchEntityType,
    AdvancedSearchRequest,
    BridgeEntityResult,
    GetCustomListsQuery,
} from "generated/graphql";

export const audienceEntityTypes = [
    AdvancedSearchEntityType.Client,
    AdvancedSearchEntityType.Community,
    AdvancedSearchEntityType.CommunityContact,
    AdvancedSearchEntityType.ReferenceContact,
];

export const makeInitialAudienceSearchRequest = (
    entities: BridgeEntityResult[],
    entityType: AdvancedSearchEntityType,
    regionId: RegionId,
    hasMultipleRegions: boolean,
    regions: TenantRegion[],
    currentUserId: UserId,
    customLists: GetCustomListsQuery["getCustomLists"],
): AdvancedSearchRequest => {
    const request = makeInitialAdvancedSearchRequest(
        entities,
        entityType,
        regionId,
        hasMultipleRegions,
        regions,
        currentUserId,
        customLists,
    );

    switch (entityType) {
        case AdvancedSearchEntityType.Client: {
            request.select = [
                { fieldName: "name" },
                { fieldName: "email" },
                { fieldName: "bestContactEntity.name" },
                { fieldName: "bestContactEntity.email1" },
                { fieldName: "status" },
                { fieldName: "assignedUserId" },
            ];
            break;
        }
        case AdvancedSearchEntityType.Community: {
            request.select = [{ fieldName: "name" }, { fieldName: "email" }];
            break;
        }
        case AdvancedSearchEntityType.CommunityContact: {
            request.select = [
                { fieldName: "contact.name" },
                { fieldName: "contact.email1" },
                { fieldName: "primary" },
            ];
            break;
        }
        case AdvancedSearchEntityType.ReferenceContact: {
            request.select = [
                { fieldName: "contactEntity.name" },
                { fieldName: "contactEntity.email1" },
                { fieldName: "business.businessContactEntity.name" },
            ];
        }
    }

    return request;
};
